import { render, staticRenderFns } from "./regDelHistory.vue?vue&type=template&id=473afca5&scoped=true&lang=pug&"
import script from "./regDelHistory.vue?vue&type=script&lang=js&"
export * from "./regDelHistory.vue?vue&type=script&lang=js&"
import style0 from "./regDelHistory.vue?vue&type=style&index=0&id=473afca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473afca5",
  null
  
)

export default component.exports